import TimeDeclaration from './Time';
import DateDeclaration from './Date';
import DateTimeDeclaration from './DateTime';
import IdDeclaration from './Id';
import CurrentMemberPointDeclaration from './CurrentMemberPoint';
import CurrentMemberGradeDeclaration from './CurrentMemberGrade';
import SelectorDeclaration from './Selector';
import SelectorValueDeclaration from './SelectorValue';


export const Id = IdDeclaration;
export const Time = TimeDeclaration;
export const Date = DateDeclaration;
export const DateTime = DateTimeDeclaration;
export const CURRENT_MEMBER_POINT = CurrentMemberPointDeclaration;
export const CURRENT_MEMBER_GRADE = CurrentMemberGradeDeclaration;
export const Selector = SelectorDeclaration;
export const SelectorValue = SelectorValueDeclaration;
